import { IParticipant, ITournament, ITournamentGame } from "../interfaces/tournament";
import { authStore } from "../stores";

class TournamentApiService {

  async getActiveTournaments(gameId: number, partnerId: number, currency: string): Promise<ITournament[]> {
    try {
      const response = await fetch(`${process.env.REACT_APP_TOURNAMENT_API_URL}/api/v1/Tournaments?gameId=${gameId}&partnerId=${partnerId}&currency=${currency}`, {
        method: 'GET',
      });
      const data = await response.json();
      return data.data;
    } catch (err) {
      return [];
    }
  }

  async getTournamentGames(id: number): Promise<ITournamentGame> {
    const response = await fetch(`${process.env.REACT_APP_TOURNAMENT_API_URL}/api/v1/Tournaments/${id}/Games`, {
      method: 'GET',
    });
    const data = await response.json();
    return data.data;
  }

  async getCurrentUserLeaderboardPosition(tournamentId: number): Promise<IParticipant | null> {
    try {
      const response = await fetch(`${process.env.REACT_APP_TOURNAMENT_API_URL}/api/v1/Tournaments/${tournamentId}/Leaderboard/CurrentUser`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authStore.accessToken}`,
        },
      });
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching current user leaderboard position:', error);
      return null;
    }
  }

  async getTopPlayers(tournamentId: number, limit: number = 10): Promise<IParticipant[]> {
    const response = await fetch(`${process.env.REACT_APP_TOURNAMENT_API_URL}/api/v1/Tournaments/${tournamentId}/Leaderboard?limit=${limit}`, {
      method: 'GET',
    });
    const data = await response.json();
    return data.data;
  }

  async getUnseenParticipantNotifications(): Promise<IParticipant[]> {
    const response = await fetch(`${process.env.REACT_APP_TOURNAMENT_API_URL}/api/v1/Participants/Notifications/Unseen`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authStore.accessToken}`,
      },
    });
    const data = await response.json();
    return data.data;
  }

  async getTournamentById(id: number): Promise<ITournament | null> {
    const response = await fetch(`${process.env.REACT_APP_TOURNAMENT_API_URL}/api/v1/Tournaments/${id}`, {
      method: 'GET',
    });
    const data = await response.json();
    return data.data;
  }

  async markNotificationAsSeen(tournamentId: number): Promise<void> {
    const response = await fetch(`${process.env.REACT_APP_TOURNAMENT_API_URL}/api/v1/Participants/Notifications/MarkAsSeen`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authStore.accessToken}`,
      },
      body: JSON.stringify({ tournamentId }),
    });

    if (!response.ok) {
      throw new Error('Failed to mark notification as seen');
    }
  }

}

export const tournamentApiService = new TournamentApiService();